import { RdpIconUrl } from "@p0security/shared/integrations/constants";
import { AzureIntegration } from "@p0security/shared/integrations/resources/azure/types";
import { RdpComponents } from "@p0security/shared/integrations/resources/rdp/components";
import { useFirestoreDoc } from "providers/FirestoreProvider";
import { useCallback } from "react";

import { Install, InstallProps } from "../Install/Install";
import { rdpInstaller } from "./install/install";

export const API_PATH = "integrations/rdp/config";

export const Rdp = (
  props: Pick<InstallProps<typeof RdpComponents>, "cardOverride" | "onInstall">
) => {
  const itemKind = useCallback(() => "subscription", []);

  const azureDoc = useFirestoreDoc<AzureIntegration>("integrations/azure", {
    tenantAware: true,
  });

  return (
    <Install<typeof RdpComponents>
      components={RdpComponents}
      installer={rdpInstaller(azureDoc)}
      integration="rdp"
      itemKind={itemKind}
      logo={RdpIconUrl}
      title={"RDP"}
      {...props}
    />
  );
};
